const WhyAnytimeSection = () => {
    return (
      <section
        id="why-anytime"
        className="h-screen bg-purple-100 flex justify-center items-center"
      >
        <h1 className="text-4xl font-bold text-center">
          Why Anytime Software Section
        </h1>
      </section>
    );
  };

  export default WhyAnytimeSection;